<template>
  <div class="modal-content">
    <div class="form-group">
      <label>{{ props.label }}</label>
      <DxTextBox v-if="props.dxInputType === 'dxTextBox'" v-bind="props.dxInputProps" v-model="inputValue" ref="dxEditorRef">
        <DxValidator v-if="props.required" ref="dxValidatorRef">
          <DxRequiredRule :message="$t('shared.input_box.campo_requerido')" />
        </DxValidator>
      </DxTextBox>
      <DxTextArea v-if="props.dxInputType === 'dxTextArea'" v-bind="props.dxInputProps" v-model="inputValue" ref="dxEditorRef">
        <DxValidator v-if="props.required" ref="dxValidatorRef">
          <DxRequiredRule :message="$t('shared.input_box.campo_requerido')" />
        </DxValidator>
      </DxTextArea>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref } from "vue";
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from "@helpers/modal-building-helper";
import { messageBoxResult } from "@components/dialogs/message-box";
import { DxButton } from "devextreme-vue/button";
import DxTextArea from "devextreme-vue/text-area";
import DxTextBox from "devextreme-vue/text-box";
import type { IInputBoxProps } from "./models/IInputBoxProps";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";

const props = withDefaults(defineProps<IInputBoxProps>(), { required: false });
defineEmits([...modalDefinedEmits]);

const inputValue = ref<string | null>(props.dxInputProps?.value ?? null);
const dxEditorRef = ref<DxTextBox | DxTextArea>();
const dxValidatorRef = ref<DxValidator>();

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  configureButtons(modal);
});

const configureButtons = (modal: ReturnType<typeof useModalBuilder>) => {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;

  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());

  okButton.update((w) => (w.onClick = () => {
    if (!props.required) {
      modal.close({ result: messageBoxResult.ok, value: inputValue.value });
      return;
    }

    const validationResult = dxValidatorRef.value!.instance!.validate();
    if (validationResult.isValid) {
      modal.close({ result: messageBoxResult.ok, value: inputValue.value });
    } else {
      dxValidatorRef.value!.instance!.focus();
    }
  }));

  cancelButton.update((w) => (w.onClick = () => modal.close({ result: messageBoxResult.cancel })));
};
</script>

<style scoped lang="scss"></style>
